"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import CouponDataItem from "@/views/costItems/components/CouponDataItem.vue";
import { PaymentController } from "@/service/newProdect";
let PaymentNewCouponDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.coupondialog = new UiDialogController();
    this.selectedCoupon = null;
  }
  paymentChange() {
  }
  confirmCoupons() {
    this._options.selected.paymentCoupon = this.selectedCoupon;
    this.$emit("paymentChange");
    this.selectedCoupon = null;
    this.coupondialog.visible = false;
  }
  close() {
    this.selectedCoupon = null;
    this.coupondialog.visible = false;
  }
  open() {
    this.coupondialog.visible = true;
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewCouponDialog.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentCoupon", {
    default: function() {
      return [];
    }
  })
], PaymentNewCouponDialog.prototype, "_paymentCoupons", 2);
PaymentNewCouponDialog = __decorateClass([
  Component({
    components: {
      CouponDataItem,
      UiDialog
    }
  })
], PaymentNewCouponDialog);
export {
  PaymentNewCouponDialog as default
};
